/** Lade-, Leer- und Fehlerzustand. Bewusst ruhig, kein Effekt. */
import { useT } from "../i18n/index.tsx";
import "./States.css";

export function LoadingState({ label }: { label?: string }): React.JSX.Element {
  const t = useT();
  return (
    <div className="state" role="status" aria-live="polite">
      <div className="state__bar"><span /></div>
      <p className="state__text">{label ?? t("common.loading")}</p>
    </div>
  );
}

export function EmptyState({ title, hint }: { title: string; hint?: string }): React.JSX.Element {
  return (
    <div className="state">
      <p className="state__title">{title}</p>
      {hint && <p className="state__text">{hint}</p>}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }): React.JSX.Element {
  const t = useT();
  return (
    <div className="state state--error" role="alert">
      <p className="state__title">{t("common.errorTitle")}</p>
      <p className="state__text">{message}</p>
      {onRetry && <button className="btn" onClick={onRetry}>{t("common.retry")}</button>}
    </div>
  );
}

/**
 * Stellt einen unbekannten Wert dar.
 * NULL ist nicht 0 und nicht "leer" (HOMEBASE_ARCHITECTURE.md 7.6) --
 * die Oberflaeche macht das sichtbar, statt es zu verschlucken.
 */
export function Unknown(): React.JSX.Element {
  const t = useT();
  return <span className="unknown" title={t("common.unknownValueTitle")}>{t("common.unknownValue")}</span>;
}
